/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useMutation } from "@tanstack/react-query";
import { patchUser } from "./queryFunctions";
import { queryClient } from "@/utils/queryClient";

export const usePatchUser = () => {
  return useMutation({ mutationFn: patchUser, 
    onSuccess: (_data, context) => {
      queryClient.invalidateQueries({
        queryKey: ["user-info", context.userId],
      });
    }
  });
};
